import moment from "moment";

/**
 * Format a date
 *
 * @param {String}    str
 * @param {String}    format
 * @param {Boolean}   withTime
 * @param {Boolean}   isLocal - Whether to display time in user's local timezone
 *
 * @returns {String} The formatted date
 */
export default function formatDate(str, format = "MMM DD, YYYY", withTime = false, isLocal = false) {
  if (!str) return "—";

  let date = moment(str);

  if (!isLocal) {
    date = date.utc();
  }

  return withTime ? date.format(`${format}, h:mm a z`) : date.format(format);
}
